var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMobileMode)?_c('mobileContact'):_c('pcContact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }